import React from "react";
import styled from '@emotion/styled'

const StyledSection = styled('section')`
scroll-snap-align: start;
`

const section = ({children, background, classes}) => (
  <StyledSection
    className={`section-container ${classes}`}
    style={{ backgroundColor: background }}
  >
    {children}
  </StyledSection>
);

export default section;



// WEBPACK FOOTER //
// ./src/components/UI/Section.js